export default "__VITE_ASSET__C3s$o9k4__"